module.exports = __webpack_public_path__ + "media/images/pro_subscription/carousel2-fr@2x-c40cee70cbf3d19bbc9c87835ca085df.png";